import React from 'react';
import { Section, SectionHeading } from './Shared';
const points = ['Llegas sin saber qué serie prescribir', 'Improvisas, sin un protocolo que te respalde', 'Absorbes la carga energética del paciente', 'Armas cada sesión desde cero', 'Sin ficha clínica ni continuidad', 'Pacientes que no regresan'];
export const PainPoints = () => <Section className="max-w-4xl" data-id="element-184" data-mp="2bvoe3v0w81tp">
    <SectionHeading eyebrow="El punto de partida" className="mb-7" data-id="element-185" data-mp="1xxzqifffygky">
      ¿Cuántas sesiones más vas a improvisar sin un sistema clínico?
    </SectionHeading>

    <p className="text-center max-w-2xl mx-auto mb-8 text-base md:text-lg font-display text-brand-textLight" data-id="element-186" data-mp="220o04pbzbriz">
      Saber Chi Kung no es lo mismo que tener un sistema clínico para aplicarlo
      con autoridad profesional.{' '}
      <span className="text-brand-burgundy italic" data-id="element-187" data-mp="3idl7lnxut6o7">
        Y esa diferencia se siente en cada consulta.
      </span>
    </p>

    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2.5 max-w-3xl mx-auto mb-8" data-id="element-188" data-mp="3ncxto6gwi9pq">
      {points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-189" data-mp="1yzdm4jp9m7lh">
          <span aria-hidden="true" className="mt-2 w-1.5 h-1.5 rotate-45 bg-brand-burgundy shrink-0" data-id="element-190" data-mp="1u23qgmba8zp7" />
          <span className="text-brand-text text-sm" data-id="element-191" data-mp="27sgy0nk9ice0">{point}</span>
        </li>)}
    </ul>

    <p className="text-center text-xl md:text-2xl font-display font-semibold purple-gradient-text" data-id="element-192" data-mp="23sol5ynu5k2u">
      ¿Y si esta fuera la última sesión que trabajas así?
    </p>
  </Section>;